import React from 'react';
const Subscribe = () => {
    return (
        <div className='subscribe bg-[#03054D]'>
            <div className="container mx-auto px-5">
                <div className="py-20 subscribe grid grid-cols md:grid-cols-2 justify-center items-center">
                {/* Subscribe to our newsletter */}
                    <h2 className="text-4xl font-bold text-[#01CFC9] mb-5">
                        Ready to get <br className='hidden md:block' /> treatment?
                    </h2>
                    <div className="px-5 flex flex-col">
                        <p className="text-white font-medium mb-4 text-left">Send us request to get quotation.</p>
                       <div className="flex flex-col flex-wrap lg:flex-row">
                       <input
                            type="text"
                            placeholder="Please Write your email"
                            className="input input-bordered input-accent w-full mb-5 max-w-xs mr-5"
                        />
                        <button className="btn-style h-12">Get Started</button>
                       </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Subscribe;